<template>
  <content-panel class="panel-tabs">
    <el-tabs v-model="activeName" @tab-click="handleClick" class="tabs" v-if="tabsShow">
      <el-tab-pane label="年度销售产品上新概览" name="yaerNewProductOverview"></el-tab-pane>
      <el-tab-pane label="价格段分布" name="priceDistribution"></el-tab-pane>
      <el-tab-pane label="月均销量过百的产品价格段分布" name="ProductSalesVolume"></el-tab-pane>
      <el-tab-pane label="月均销售数量段分布" name="monthSalesVolumes"></el-tab-pane>
      <el-tab-pane label="销量表现" name="yaerProductSales"></el-tab-pane>
      <el-tab-pane label="销售数据同期比" name="DataSynchronizationRatio"></el-tab-pane>
    </el-tabs>
    <component :is="activeNameComponent" v-if="activeName"></component>
  </content-panel>
</template>

<script>
import yaerNewProductOverview from "./components/yaerNewProductOverview.vue";
import priceDistribution from "./components/priceDistribution.vue";
import ProductSalesVolume from "./components/ProductSalesVolume.vue";
import monthSalesVolumes from "./components/monthSalesVolumes.vue";
import yaerProductSales from "./components/yaerProductSales.vue";
import DataSynchronizationRatio from "./components/DataSynchronizationRatio.vue";
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  name: "ProBehaviorYear",
  mixins: [pagePathMixin],
  components: {
    yaerNewProductOverview,
    priceDistribution,
    ProductSalesVolume,
    monthSalesVolumes,
    yaerProductSales,
    DataSynchronizationRatio,
  },
  data() {
    return {
      activeName: "",
      tabsShow: true,
      queryData: {},
    };
  },
  watch: {
    $route: {
      handler(val, olv) {
        if (  //跳转tab不是当前选中页时
          (olv.path == "/yearBehavior" || olv.path == "/productLifeCycle/administration") &&
          val.query.activeName != this.activeName &&
          JSON.stringify(val.query) != "{}"
        ) {
          this.queryData = val.query;
          this.activeName = this.$route.query.activeName || "yaerNewProductOverview";
          this.tabsShow = false;
          setTimeout(() => {
            this.tabsShow = true;
          }, 70);
        } else if ( //跳转tab页时当前tab页但传参不一样时
          JSON.stringify(val.query) != "{}" &&
          JSON.stringify(this.queryData) != "{}" &&
          (val.query.startTime != this.queryData.startTime ||
            val.query.endTime != this.queryData.endTime) &&
          this.activeName == this.queryData.activeName
        ) {
          this.activeName = "";
          setTimeout(() => {
            this.activeName = this.queryData.activeName;
          }, 70);
          this.queryData = val.query;
        }
      },
    },
  },
  computed: {
    activeNameComponent() {
      return this.activeName;
    },
  },
  mounted() {
    this.activeName = this.$route.query.activeName || "yaerNewProductOverview";
    this.queryData = this.$route.query;
    
  },
  methods: {
    handleClick() {},
  },
};
</script>

<style scoped lang="stylus">
.panel-tabs
  >>> .main-area
    padding-top 0
.tabs
  >>> .el-tabs__header
    margin-bottom 5px
</style>

